/**
 * @generated SignedSource<<0c2120dbb46e31c003e1c5b870e9775d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShippingDetailsQuotesTable_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"ShippingDetailsPromo_item" | "ShippingDetailsQuotesTableRow_item">;
  readonly " $fragmentType": "ShippingDetailsQuotesTable_item";
};
export type ShippingDetailsQuotesTable_item$key = {
  readonly " $data"?: ShippingDetailsQuotesTable_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShippingDetailsQuotesTable_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShippingDetailsQuotesTable_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShippingDetailsQuotesTableRow_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShippingDetailsPromo_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "4949a012cd52031a6c8c02a8d66524d9";

export default node;
